import { Configuration, FrontendApi } from '@ory/client';

const { REACT_APP_ORY_BASE_URL: ORY_BASE_URL } = process.env;
const { REACT_APP_ACCOUNTS_BASE_URL: ACCOUNTS_URL } = process.env;
const { REACT_APP_CLIENT_ROOT: NISO_ROOT } = process.env;

export const redirectToSignIn = () =>
  window.location.assign(`${ACCOUNTS_URL}/customers/sign-in?returnTo=${NISO_ROOT}`);

export const getOrySession = async () => {
  const { data } = await OryClient.toSession();
  return { session: data };
};

export const destroyOrySession = async () => {
  try {
    const { data: flow } = await OryClient.createBrowserLogoutFlow();
    await OryClient.updateLogoutFlow({
      token: flow.logout_token,
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
};

export const getSessionToken = (id, guid) => Buffer.from(`${id};${guid}`).toString('base64');

const OryClient = new FrontendApi(
  new Configuration({
    basePath: ORY_BASE_URL,
    baseOptions: {
      withCredentials: true,
    },
  }),
);

export default OryClient;
